import { resourceReducer, getResources } from 'redux-resource';
import { httpStatusCodes } from 'redux-resource-plugins';

const insuranceDevices = resourceReducer('insurancePlans', {
  plugins: [httpStatusCodes],
});

export default insuranceDevices;

export const getInsurancePlan = (state, id) => getResources(state, [id])[0];
